import { render, staticRenderFns } from "./StockDetails.vue?vue&type=template&id=4d041274"
import script from "./StockDetails.vue?vue&type=script&lang=js"
export * from "./StockDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d041274')) {
      api.createRecord('4d041274', component.options)
    } else {
      api.reload('4d041274', component.options)
    }
    module.hot.accept("./StockDetails.vue?vue&type=template&id=4d041274", function () {
      api.rerender('4d041274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/StockDetails.vue"
export default component.exports